import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { KEY } from "@/shared/constants/keyboard";
import sprites from "/src/shared/assets/sprite.svg";
import { investingCharacteristicRatingTooltips } from "../../../config";
import type { InvestingCharacteristicRatingTooltip } from "../../../types";

interface RatingProps {
	defaultValue?: number;
	value?: number;
	onChange?: (value: number) => void;
	readOnly?: boolean;
	type?: InvestingCharacteristicRatingTooltip;
}

export const Rating = ({
	defaultValue = 1,
	value,
	onChange,
	readOnly = false,
	type = "default",
}: RatingProps) => {
	const ratings = [1, 2, 3, 4];

	const handleClick = (rating: number) => {
		if (!readOnly) {
			if (onChange) {
				onChange(rating);
			}
		}
	};

	return (
		<div className="flex items-center !my-0">
			{ratings.map((rating) => (
				<Tooltip key={rating}>
					<TooltipTrigger asChild>
						<svg
							aria-label="rating-arrow"
							role="img"
							fill={
								rating <= (value || defaultValue)
									? "var(--gold)"
									: "var(--dark-background)"
							}
							onClick={() => handleClick(rating)}
							onKeyDown={(e) => e.key === KEY.ENTER && handleClick(rating)}
							className={`w-5 h-5 transition-colors duration-200 ${
								!readOnly && "cursor-pointer"
							}`}
						>
							<use xlinkHref={`${sprites}#rating-arrow`} />
						</svg>
					</TooltipTrigger>
					<TooltipContent>
						{investingCharacteristicRatingTooltips[type][rating - 1]}
					</TooltipContent>
				</Tooltip>
			))}
		</div>
	);
};
